var _path, _g, _mask, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriggerShortDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3447_60294",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 5,
    width: 7,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5H8V19H15V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3447_60294)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.579 10.2276H11.7997L12.9596 5.43712C12.9811 5.30161 12.9381 5.1682 12.85 5.1129C12.8285 5.08624 12.7854 5.08624 12.7621 5.08624C12.6974 5.08624 12.631 5.13968 12.5879 5.19498L8.1031 13.2858C8.05999 13.3658 8.05999 13.4746 8.08152 13.5567C8.12638 13.6367 8.19095 13.6901 8.27903 13.6901H10.9686L9.76572 18.5605C9.74419 18.696 9.78899 18.8315 9.87527 18.8868C9.89685 18.9135 9.94165 18.9135 9.96318 18.9135C10.0296 18.9135 10.0943 18.86 10.1374 18.8047L14.7533 10.6341C14.7749 10.5786 14.7982 10.5254 14.7982 10.4719C14.7982 10.3364 14.6886 10.2276 14.579 10.2276Z",
    fill: "#A2A2A2"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_3447_60294",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24H0ZM24 24H0H24ZM4 24C1.23858 24 -1 21.7614 -1 19V5C-1 2.23858 1.23858 0 4 0C2.34315 0 1 1.79086 1 4V20C1 22.2091 2.34315 24 4 24ZM20 0C22.7614 0 25 2.23858 25 5V19C25 21.7614 22.7614 24 20 24C21.6569 24 23 22.2091 23 20V4C23 1.79086 21.6569 0 20 0Z",
    fill: "#D9D9D9",
    mask: "url(#path-3-inside-1_3447_60294)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriggerShortDark);
export default __webpack_public_path__ + "static/media/Trigger-Short-Dark.a7c0cb5ef134be8bb2148cfcdf3cf43f.svg";
export { ForwardRef as ReactComponent };